// extracted by mini-css-extract-plugin
export default {"clock-container":"Clock_clock-container__RzkCG","clock-time":"Clock_clock-time__R1YyO","clock-date":"Clock_clock-date__8igGF","weather-container":"Clock_weather-container__+7C5B"};